/* unplugin-vue-components disabled */import script from "./filter-tags.vue?vue&type=script&setup=true&lang=js"
export * from "./filter-tags.vue?vue&type=script&setup=true&lang=js"

import "./filter-tags.vue?vue&type=style&index=0&id=7ef556fc&lang=less"

const __exports__ = script;

export default __exports__